import React from 'react';
import PropTypes from 'prop-types';

// Utils
import bemify from 'utils/bemify';

// Components
import Button from 'components/button';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const NoResultsSection = ({
  buttonText = null,
  className = null,
  description = null,
  imageComponent = null,
  onButtonClick = () => {},
  title = null
}) => {
  if (!title) return null;

  return (
    <section className={`${styles.noResultsSection}${className ? ` ${className}` : ''}`}>
      <div className={styles.noResultsSection__content}>
        <div className={styles.noResultsSection__image}>
          {imageComponent}
        </div>
        <div className={styles.noResultsSection__textWrapper}>
          <h6 className={styles.noResultsSection__title}>
            {title}
          </h6>
          {!!description && (
            <p className={styles.noResultsSection__description}>
              {description}
            </p>
          )}
        </div>
        {!!buttonText && !!onButtonClick && (
          <Button
            text={buttonText}
            onClick={onButtonClick}
          />
        )}
      </div>
    </section>
  );
};

NoResultsSection.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  imageComponent: PropTypes.element,
  onButtonClick: PropTypes.func,
  title: PropTypes.string
};

export default NoResultsSection;
